import { useUpdateEffect } from 'react-use';
import * as React from 'react';

const COUNT_TIME_IN_MILLISECONDS = 1000;

export const useCountDownTimer = (
  initialTimeInSeconds: number,
  timerCallback?: (timeInSeconds: number) => void,
  countDownTimeInMilliseconds?: number
) => {
  const [timerStarted, setTimerStarted] = React.useState(false);
  const [countDownTime, setCountDownTime] = React.useState(initialTimeInSeconds);
  const timerInterval = React.useRef<any>(null);
  const ms = countDownTimeInMilliseconds || COUNT_TIME_IN_MILLISECONDS;

  const startTimer = () => {
    setTimerStarted(true);
  };

  const stopTimer = () => {
    setTimerStarted(false);
  };

  const destroyTimer = () => {
    stopTimer();
    clearInterval(timerInterval.current);
  };

  useUpdateEffect(() => {
    if (!timerStarted || countDownTime <= 0) {
      setCountDownTime(initialTimeInSeconds);
    }
  }, [initialTimeInSeconds]);

  // Time counter
  useUpdateEffect(() => {
    if (timerStarted) {
      timerInterval.current = setInterval(() => {
        setCountDownTime((prevTime) => {
          return prevTime - ms / 1000;
        });
      }, ms);

      return function unmount() {
        clearInterval(timerInterval.current);
      };
    }

    return undefined;
  }, [timerStarted]);

  useUpdateEffect(() => {
    if (countDownTime <= 0) {
      setCountDownTime(0);
      destroyTimer();
      timerCallback?.(0);
    }

    if (countDownTime > 0) {
      timerCallback?.(countDownTime);
    }
  }, [countDownTime]);

  return {
    countDownTimeInSeconds: Math.max(countDownTime, 0),
    startTimer,
    stopTimer,
    destroyTimer,
    setCountDownTime,
    timerStarted,
  };
};
